import { RetirementType } from "@/app/pages/recs/retire/retire.types";
import {
  AssetType,
  CertificateType,
  CommodityTransactionStatus,
  RetirementCategory,
  RetirementStatus,
  RetirementSummaryQuery,
  VintageHalf,
} from "@/app/types/generated/graphql";

export const retirementByIdQuery = {
  read(_: RetirementSummaryQuery["retirementById"]) {
    return demoMretsRetirementSummary;
  },
};

export const demoMretsRetirementSummary: RetirementSummaryQuery["retirementById"] = {
  id: "1",
  accountId: "12345",
  retirementNumber: "RET-2023-0001",
  requestedOn: "2023-05-15T10:00:00Z",
  completedOn: "2023-05-20T10:00:00Z",
  retirementCategory: RetirementCategory.Voluntary,
  retirementType: RetirementType.GREEN_E_CERTIFIED_VOLUNTARY_MARKET,
  totalVolume: 1000,
  retirementDetails: {
    notes: "Full retirement of assets for Q2 2023",
    reason: "Reason",
    compliancePeriod: "2022-12-02",
  },
  status: RetirementStatus.Retired,
  statusMessage: `<main>
          <ul>
            <li>Web Design</li>
            <li>Graphic Design</li>
            <li>SEO Services</li>
            <li>Content Writing</li>
        </ul>
        </main>`,
  assetType: AssetType.Rec,
  commodityDetails: [
    {
      __typename: "RetireCommodityDetail",
      id: "c1",
      volume: 1000,
      status: RetirementStatus.Retired,
      statusMessage: "Commodity retired successfully",
      attributes: {
        __typename: "MretsRecAttributes",
        vintage: 2022,
        vintageHalf: VintageHalf.FrontHalf,
        location: "AL",
        fuelSources: ["WND", "HYD"],
        eligibilities: ["ia_aep", "ia"],
        project: "Chipmunk-Solar",
        certificateType: CertificateType.R,
        certifications: ["CRS"],
        commencementDate: "2022-01-01",
      },
      commodityTransactions: [
        {
          __typename: "CommodityTransaction",
          id: "t1",
          status: CommodityTransactionStatus.Success,
          statusMessage: "Transaction verified",
          volume: 1000,
          commoditySerial: {
            __typename: "CommoditySerial",
            serialPrefix: "CS",
            serialFrom: "0001",
            serialTo: "1000",
          },
          generator: {
            id: "g1",
            crsEffectiveDate: "2023-05-15",
            crsExpiryDate: "2023-10-15",
          },
        },
        {
          __typename: "CommodityTransaction",
          id: "t2",
          status: CommodityTransactionStatus.Success,
          volume: 1000,
          statusMessage: "Transaction pending verification",
          commoditySerial: {
            __typename: "CommoditySerial",
            serialPrefix: "CS",
            serialFrom: "1001",
            serialTo: "2000",
          },
          generator: {
            id: "g1",
          },
        },
      ],
    },
  ],
};
export const demoErcotRetirementSummary: RetirementSummaryQuery["retirementById"] = {
  id: "1",
  accountId: "12345",
  retirementNumber: "RET-2023-0001",
  requestedOn: "2023-05-15T10:00:00Z",
  completedOn: "2023-05-20T10:00:00Z",
  retirementCategory: RetirementCategory.Voluntary,
  retirementType: RetirementType.GREEN_E_CERTIFIED_VOLUNTARY_MARKET,
  totalVolume: 1000,
  retirementDetails: {
    notes: "Full retirement of assets for Q2 2023",
    reason: "Reason",
    compliancePeriod: "2022-12-02",
  },
  status: RetirementStatus.Retired,
  statusMessage: `<main>
          <ul>
            <li>Web Design</li>
            <li>Graphic Design</li>
            <li>SEO Services</li>
            <li>Content Writing</li>
        </ul>
        </main>`,
  assetType: AssetType.Rec,
  commodityDetails: [
    {
      __typename: "RetireCommodityDetail",
      id: "c1",
      volume: 1000,
      status: RetirementStatus.Retired,
      statusMessage: "Commodity retired successfully",
      attributes: {
        __typename: "ErcotRecAttributes",
        vintage: 2022,
        vintageHalf: VintageHalf.Q1,
        certifications: ["CRS"],
        fuelSources: ["GT"],
        project: "GHG Emission Control",
        certificateType: CertificateType.Cp,
      },
      commodityTransactions: [
        {
          __typename: "CommodityTransaction",
          id: "t1",
          status: CommodityTransactionStatus.Success,
          statusMessage: "Transaction verified",
          volume: 1000,
          commoditySerial: {
            __typename: "CommoditySerial",
            serialPrefix: "CS",
            serialFrom: "0001",
            serialTo: "1000",
          },
          generator: {
            id: "g1",
            crsEffectiveDate: "2023-05-15",
            crsExpiryDate: "2023-10-15",
          },
        },
        {
          __typename: "CommodityTransaction",
          id: "t2",
          status: CommodityTransactionStatus.Success,
          volume: 1000,
          statusMessage: "Transaction pending verification",
          commoditySerial: {
            __typename: "CommoditySerial",
            serialPrefix: "CS",
            serialFrom: "1001",
            serialTo: "2000",
          },
          generator: {
            id: "g1",
          },
        },
      ],
    },
  ],
};
